/**
 * Regra da "Contratação simplificada (dispensar endereço)".
 *
 * O endereço só pode ser dispensado quando o link aceita exclusivamente Pix
 * e/ou Cartão de Crédito. Com Boleto habilitado o endereço do pagador é
 * obrigatório para o registro do título, então o backend ignora a flag
 * (`ProductLink#init_payment_types` zera `simplified_checkout` no before_save).
 *
 * Antes essa reversão era silenciosa: o merchant ligava o switch, salvava, a API
 * respondia 200 e o checkout continuava pedindo endereço. Aqui a combinação é
 * barrada no front para que ele entenda o motivo.
 */

/** Meios de pagamento que exigem endereço do pagador. */
const PAYMENT_TYPES_REQUIRING_ADDRESS = ['boleto', 'boleto_pix']

export const SIMPLIFIED_CHECKOUT_BOLETO_ERROR =
  'A contratação simplificada não pode ser usada com Boleto, que exige o endereço do pagador. Desative o Boleto ou desligue a contratação simplificada.'

/**
 * Verifica se algum dos meios selecionados exige endereço.
 * `payments` é o array da UI (pix, boleto, credit_card); `boleto_pix` não tem
 * checkbox próprio e é derivado pelo backend, mas é checado por segurança.
 */
export const paymentsRequireAddress = (payments?: unknown): boolean =>
  Array.isArray(payments) &&
  payments.some((payment) =>
    PAYMENT_TYPES_REQUIRING_ADDRESS.includes(payment as string)
  )

/**
 * Valor que deve ir no payload `simplified_checkout`.
 *
 * O switch só é renderizado para cliente novo (`customerType === 'new'`), mas
 * `simplifiedCheckout` continua no state do form depois que o merchant troca a
 * aba para "Cliente existente" — e sem normalizar, esse resíduo era enviado,
 * o backend zerava em silêncio e o bug original voltava por outro caminho.
 * Para link amarrado a cliente existente a flag não tem controle na UI, então
 * o valor correto a enviar é sempre false.
 */
export const resolveSimplifiedCheckoutPayload = (
  customerType?: string,
  simplifiedCheckout?: boolean
): boolean => customerType === 'new' && !!simplifiedCheckout
